// extracted by mini-css-extract-plugin
export var avatarContainer = "_54-0";
export var avatarTypingWave = "_54-i";
export var gray = "_54-f";
export var green = "_54-c";
export var icon = "_54-9";
export var image = "_54-1";
export var lg = "_54-6";
export var md = "_54-5";
export var presenceDot = "_54-b";
export var red = "_54-d";
export var sm = "_54-4";
export var status = "_54-a";
export var typingDot = "_54-h";
export var typingPill = "_54-g";
export var xl = "_54-7";
export var xs = "_54-3";
export var xxl = "_54-8";
export var xxs = "_54-2";
export var yellow = "_54-e";